export class AfiliadoService{
    static getId(){
        return localStorage.getItem("iduser");
    }
}